export default __webpack_public_path__ + "static/media/get-started-kubernetes.283097c3.svg";